import { graphql, useFragment } from 'utils/graphClient';
import { useItemHandleFragment$key } from './__generated__/useItemHandleFragment.graphql';
import { useItemHandleQuery } from './__generated__/useItemHandleQuery.graphql';

const itemFragment = graphql`
  fragment useItemHandleFragment on Node {
    __typename
    id
    ... on HasOwnerPermissionsInterface {
      ownershipSpace {
        id
      }
      ownershipEvent {
        id
      }
      ownershipFolders(last: 1) {
        nodes {
          id
        }
      }
    }
    ... on Announcement {
      announcementDate: publishedAt
      announcer {
        id
        name
      }
      link {
        item {
          ... on Node {
            id
            ... on Event {
              name
            }
            ... on Folder {
              name
            }
            ... on FolderItem {
              name
            }
            ... on AnnouncementAttachment {
              content {
                __typename
                ... on File {
                  name
                }
              }
            }
          }
        }
      }
    }
    ... on AnnouncementAttachment {
      thumbnail {
        url
      }
      content {
        __typename
        ... on File {
          id
          name
          mimeType
          url
        }
      }
    }
    ... on MemberDetailsAttachment {
      thumbnail {
        url
      }
      content {
        __typename
        ... on File {
          id
          name
          mimeType
          url
        }
      }
    }
    ... on Folder {
      name
      space {
        id
      }
      publishedAt
      lastModifiedAt
      thumbnail {
        url
      }
    }
    ... on FolderItem {
      name
      label
      publishedAt
      lastModifiedAt
      content {
        __typename
        ... on Page {
          id
          title
          data
        }
        ... on File {
          id
          mimeType
          url
        }
        ... on PendingFile {
          id
        }
        ... on Form {
          id
          questions {
            id
            text
          }
        }
        ... on ExternalBridge {
          id
          url
        }
        ... on InternalBridge {
          id
          url
        }
      }
      thumbnail {
        url
      }
      ... on HasPinsInterface {
        pins {
          context
          id
          label
        }
      }
    }
    ... on SignableInterface {
      signatureEnvelope {
        id
        status
      }
    }
    ... on VaultItem {
      ...VaultItemAccessDetails_node
      name
      uploadGroup {
        publishedAt {
          utcDate
          utcTime
        }
        publisher {
          name
        }
      }
      content {
        __typename
        ... on File {
          id
          mimeType
          url
        }
        ... on PendingFile {
          id
        }
      }
    }
    ... on Event {
      name
    }
    ... on Member {
      name
      ...UserAvatar_member
    }
    ... on Vault {
      name
      thumbnail {
        url
      }
    }
    ... on Space {
      name
      color {
        light
        dark
      }
      # icon {
      #   ... on NamedIcon {
      #     name
      #   }
      # }
    }
  }
`;

export interface useItemHandleFragmentProps {
  // This type is not 100% correct, but will do for now.
  item: useItemHandleFragment$key | useItemHandleQuery;
}

export const useItemHandleFragment = ({ item }: useItemHandleFragmentProps) =>
  useFragment(itemFragment, item as useItemHandleFragment$key);
